require.register("modules/m02/m02-activity/page-6a/page-6a", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page6a = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {
    view.subscribeEvent('block:values:change', (e) => {
      view.$('form').submit();
    });
  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page6a;

  
});

